/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { Int32NullableListSearch } from './Int32NullableListSearch';
import {
    Int32NullableListSearchFromJSON,
    Int32NullableListSearchFromJSONTyped,
    Int32NullableListSearchToJSON,
} from './Int32NullableListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface CalendrierSearch
 */
export interface CalendrierSearch {
    /**
     * 
     * @type {Int32NullableListSearch}
     * @memberof CalendrierSearch
     */
    idcentre?: Int32NullableListSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof CalendrierSearch
     */
    libelle?: TextSearch;
    /**
     * 
     * @type {number}
     * @memberof CalendrierSearch
     */
    idUser?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CalendrierSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof CalendrierSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof CalendrierSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CalendrierSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof CalendrierSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof CalendrierSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the CalendrierSearch interface.
 */
export function instanceOfCalendrierSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CalendrierSearchFromJSON(json: any): CalendrierSearch {
    return CalendrierSearchFromJSONTyped(json, false);
}

export function CalendrierSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalendrierSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcentre': !exists(json, 'idcentre') ? undefined : Int32NullableListSearchFromJSON(json['idcentre']),
        'libelle': !exists(json, 'libelle') ? undefined : TextSearchFromJSON(json['libelle']),
        'idUser': !exists(json, 'idUser') ? undefined : json['idUser'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function CalendrierSearchToJSON(value?: CalendrierSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcentre': Int32NullableListSearchToJSON(value.idcentre),
        'libelle': TextSearchToJSON(value.libelle),
        'idUser': value.idUser,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

